import React from "react";
import { OrganisationOUT } from "api-client";
import useSidebarMenu from "../useSidebarMenu";
import DashboardMenu, { DashboarMenuItem } from "./DashboardMenu";

const AssetDashboards = ({
  organisation,
}: {
  organisation: OrganisationOUT;
}) => {
  const {
    EPDListMenuItem,
    ProductListMenuItem,
    urbanMiningMenuItem,
    portfolioAssetMenuItem,
  } = useSidebarMenu(organisation.id);

  const menuItems: DashboarMenuItem[] = [
    portfolioAssetMenuItem,
    urbanMiningMenuItem,
    ProductListMenuItem,
    EPDListMenuItem,
  ];

  return <DashboardMenu menuItems={menuItems} />;
};

export default AssetDashboards;
